import { useRoute } from "#app";

function useRequiredParams<Name extends string>(
  ...names: Name[]
): Record<Name, string> {
  const { params } = useRoute();

  return Object.fromEntries(
    names.map((name) => {
      const value = params[name];
      if (typeof value !== "string") {
        throw new Error(`Missing required route param: ${name}`);
      }
      return [name, value];
    }),
  ) as Record<Name, string>;
}

export { useRequiredParams };
